import * as Sentry from '@sentry/react';

export const initSentry = () => {
  const sentryEnabled = !import.meta.env.VITE_APP_DISABLE_SENTRY;

  Sentry.init({
    dsn: sentryEnabled
      ? import.meta.env.VITE_SENTRY_DSN
      : undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: [
      /^https:\/\/staging-client\.energie\.hellio\.dev/,
      /^https:\/\/dev-client\.energie\.hellio\.dev/,
    ],
  });
};
